import { FieldValues } from "react-hook-form";
import { default as TextField, Props, StringFieldName } from "../TextField/controlled";

export default function PostalCodeInput<FV extends FieldValues, Name extends StringFieldName<FV>>({
  isUSA,
  rules,
  ...props
}: Props<FV, Name> & { isUSA: boolean }) {
  return (
    <TextField
      label={isUSA ? "Zip" : "Postal Code"}
      rules={{
        pattern: { value: isUSA ? /^\d{5}(-\d{4})?$/ : /^.*$/, message: "must be a zip" },
        ...rules
      }}
      {...props}
    />
  );
}
